import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import styles from "./BookingPanel.module.css"

// One white block of the booking panel ("Select Date", "Add Guests", …) with an optional error line.
const PanelSection = ({ title, subtitle, error, children }) => (
  <Flex vertical gap={12} className={`${styles.section} ${error ? styles.sectionError : ""}`}>
    {(title || subtitle) && (
      <Flex vertical gap={2}>
        {title && <span className={styles.sectionTitle}>{title}</span>}
        {subtitle}
      </Flex>
    )}
    {children}
    {error && (
      <span className={styles.errorText} role="alert">
        {error}
      </span>
    )}
  </Flex>
)

PanelSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.node,
  error: PropTypes.string,
  children: PropTypes.node
}

PanelSection.defaultProps = {
  title: null,
  subtitle: null,
  error: null,
  children: null
}

export default PanelSection
